import React from 'react';
import Hero from '../../components/Hero/Hero';
import ProductGrid from '../../components/ProductGrid/ProductGrid';

const Home = () => {
  return (
    <>
      <Hero />
      <ProductGrid />
    </>
  );
};

export default Home; 